import {
  InvalidSessionError,
  TwoFactorAuthError,
} from "@tastyworks/tastyworks-api"
import { HandledError } from "./errors"
import { alertDisplay } from "./errors/text"

/////////////////////////
// Public
/////////////////////////

export function isHandledError(e: unknown): e is HandledError {
  return e instanceof HandledError
}

export function getGenericAlert() {
  return alertDisplay.generic
}

/////////////////////////
// Private
/////////////////////////

/*
Certain errors should be rethrown so each use of `tc` (and its derivatives) does not need to
remember to handle these scenarios:
  - InvalidSessionError is handled globally to redirect to /login
  - TwoFactorAuthError is caught by ChallengePrompt to prompt a user for their 2FA code
*/
export function rethrowIfHandledGlobally(e: unknown) {
  if (e instanceof InvalidSessionError || e instanceof TwoFactorAuthError) {
    throw e
  }
}
